/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.

  document.addEventListener("submit", function (e) {
    function setCookie(cname, cvalue, exdays) {
      const d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      let expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    if (e.target?.closest(".fullScreen.form")) {
      const cookieName = e.target
        .closest("[data-cookie-name]")
        ?.getAttribute("data-cookie-name");

      if (cookieName) {
        setCookie(cookieName, "user_has_closed", 365);
      }
    }
  });

  document.addEventListener("click", function (e) {
    if (
      e.target?.classList.contains("form__popup-close") &&
      e.target?.closest(".fullScreen.form")
    ) {
      document.querySelector("[data-popup-close]").click();
    }
  });

  document.addEventListener("theme:cart:change", function (e) {
    fetch(window.location.href)
      .then((response) => response.text())
      .then((html) => {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");
        
        var carbonOffsetBlock = document.querySelector('.js-cart-impact [data-carbon-offset]');
        var updatedCarbonOffsetHTML = doc.querySelector(".js-cart-impact [data-carbon-offset]")?.innerHTML;
        
        var treesPlantedBlock = document.querySelector('.js-cart-impact [data-trees-planted]');
        var updatedTreesPlantedHTML = doc.querySelector(".js-cart-impact [data-trees-planted]")?.innerHTML;
        
        var plasticRemoveBlock = document.querySelector('.js-cart-impact [data-plastic-remove]');
        var updatedPlasticRemoveHTML = doc.querySelector(".js-cart-impact [data-plastic-remove]")?.innerHTML;
        
        if (carbonOffsetBlock){
          carbonOffsetBlock.innerHTML = updatedCarbonOffsetHTML;
        }

        if (treesPlantedBlock){
          treesPlantedBlock.innerHTML = updatedTreesPlantedHTML;
        }
                
        if (plasticRemoveBlock){
          plasticRemoveBlock.innerHTML = updatedPlasticRemoveHTML;
        }
      })
      .catch((err) => console.log(err));
  });
})();
